import { c as _c } from "react/compiler-runtime";
import { useMutation } from '../../../../tanstack/entry.js';
import { updateWagerSettings } from '../../../actions/coupon/updateWagerSettings.js';
/**
 * Updates current user wager settings. Hook returns a mutation api used to persist the settings.
 *
 * @param product Product to update settings for.
 * @param settingsKey Settings key, to update settings for my bets/results.
 * @param options Hook options.
 * @param options.onSuccess Called with the persisted settings when the mutation succeeds.
 * @returns Mutation api for wager settings.
 */
export function useUpdateWagerSettings(product, settingsKey, t0) {
  const $ = _c(8);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onSuccess
  } = t1;
  let t2;
  if ($[2] !== product || $[3] !== settingsKey) {
    t2 = async formData => {
      const response = await updateWagerSettings({
        product,
        previousState: {
          status: "IDLE"
        },
        formData,
        settingsKey
      });
      if (response.status === "ERROR") {
        throw new Error(response.error);
      }
      if (response.status !== "SUCCESS") {
        throw new Error("Unknown state");
      }
      return {
        correction: response.data.correction ?? []
      };
    };
    $[2] = product;
    $[3] = settingsKey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onSuccess || $[6] !== t2) {
    t3 = {
      mutationFn: t2,
      onSuccess
    };
    $[5] = onSuccess;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useMutation(t3);
}